module.exports = __webpack_public_path__ + "16eba1fe6d19ce5f8de921badaff2f9e.png";